import { upperFirst } from 'lodash-es'

export default (message, enforceEndingPeriod = true) => {
  message = upperFirst(message)

  if (enforceEndingPeriod && message.slice(-1) !== '.') {
    message = `${message.trim()}.`
  }

  return message
}
